import type { Appearance } from "@stripe/stripe-js";

export const mergeStripeAppearance = (
  base: Appearance,
  overrides?: Pick<Appearance, "variables" | "rules">,
): Appearance => {
  const overrideRules = overrides?.rules ?? {};

  return {
    ...base,
    variables: {
      ...base.variables,
      ...overrides?.variables,
    },
    rules: {
      ...base.rules,
      ...Object.fromEntries(
        Object.entries(overrideRules).map(([selector, styles]) => [
          selector,
          { ...(base.rules?.[selector] ?? {}), ...styles },
        ]),
      ),
    },
  };
};
